import React from 'react';

interface TripHotelCardAvailabilityProps {
  hotelData: any;
  isBlocked: boolean;
  isMinStayUnmet: boolean;
  minimumStay: number;
  isIncluded: boolean;
  renderPrice: (hotelData: any) => React.ReactNode;
  hotelUnavailableLabel: React.ReactNode;
  minimumStayLabel: (count: number) => React.ReactNode;
  priceIncludedLabel: React.ReactNode;
}

/** The card's one price-or-status line: blocked, priced, min-stay warning, or included. */
export default function TripHotelCardAvailability({
  hotelData,
  isBlocked,
  isMinStayUnmet,
  minimumStay,
  isIncluded,
  renderPrice,
  hotelUnavailableLabel,
  minimumStayLabel,
  priceIncludedLabel,
}: TripHotelCardAvailabilityProps) {
  return (
    <>
      {isBlocked ? (
        <div className="mt-0.5 text-sm">
          <div className="truncate text-red-600 font-medium">
            {hotelUnavailableLabel}
          </div>
        </div>
      ) : (
        <>
          {!isIncluded && renderPrice(hotelData)}

          {isMinStayUnmet && (
            <div className="mt-0.5 text-sm">
              <div className="truncate text-red-600 font-medium">
                {minimumStayLabel(minimumStay)}
              </div>
            </div>
          )}
        </>
      )}

      {isIncluded && (
        <div className="mt-1 text-green-600 font-medium text-sm">
          {priceIncludedLabel}
        </div>
      )}
    </>
  );
}
